import logo from './logo.svg';
import './App.css';
import HiringForm from './HiringForm';
import Home from './Home';
import Navbar from './Navbar';
import Porfolio from './Portfolio';
import { useState } from 'react';
import Footer from './Footer';
import QueryForm from './QueryForm';
import ContactPage from './ContactPage';

function App() {

  const [selectedPage, setSelectedPage] = useState('Home');

  const renderPage = () => {
    switch (selectedPage) {
      case 'Home' :
        return <Home setSelectedPage = {setSelectedPage}/>;
      case 'Portfolio':
        return <Porfolio/>;
      case 'Services':
        return <HiringForm/>;
      case 'Hiring':
        return <HiringForm/>;
      case 'Contact':
        return <ContactPage/>;
      case 'Email':
        return <QueryForm/>;
      default:
        return <Home />;

    }
  };

  return (
    <div className="App">
      <Navbar setSelectedPage={setSelectedPage} selectedPage={selectedPage}/>
      {renderPage()}
      <Footer/>
    </div>
  );

  
}

export default App;
